export const unique = (values) => [ ...new Set(values) ]

export const add = (value, position = 'first') => (values) => {
  return position === 'first'
    ? [ value, ...values ]
    : [ ...values, value ]
}

export { cull as filter, filters } from 'cullender'



// WEBPACK FOOTER //
// ./src/helpers/collection.js